// @ts-nocheck
import type * as Types from '#api/shared/@types/generated/auth/graphql-schema-types';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import type * as VueCompositionApi from '@vue/composition-api';
type ReactiveFunction<TParam> = () => TParam;

export const ChangeTwoFactorConfigurationDocument = gql`
    mutation ChangeTwoFactorConfiguration($input: ChannelConfiguration!) {
  changeTwoFactorConfiguration(input: $input) {
    channels {
      activated
      channel
    }
  }
}
    `;

/**
 * __useChangeTwoFactorConfigurationMutation__
 *
 * To run a mutation, you first call `useChangeTwoFactorConfigurationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useChangeTwoFactorConfigurationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useChangeTwoFactorConfigurationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useChangeTwoFactorConfigurationMutation(options: VueApolloComposable.UseMutationOptions<Types.ChangeTwoFactorConfigurationMutation, Types.ChangeTwoFactorConfigurationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ChangeTwoFactorConfigurationMutation, Types.ChangeTwoFactorConfigurationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ChangeTwoFactorConfigurationMutation, Types.ChangeTwoFactorConfigurationMutationVariables>(ChangeTwoFactorConfigurationDocument, { clientId: 'auth', ...options});
}
export type ChangeTwoFactorConfigurationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ChangeTwoFactorConfigurationMutation, Types.ChangeTwoFactorConfigurationMutationVariables>;
export const FinishPasskeyAuthenticationDocument = gql`
    mutation FinishPasskeyAuthentication($input: FinishPasskeyAuthenticationInput!) {
  finishPasskeyAuthentication(input: $input) {
    ... on PasskeyErrorCase {
      errors
    }
    ... on TokenPayload {
      accessToken
      accessTokenType
    }
  }
}
    `;

/**
 * __useFinishPasskeyAuthenticationMutation__
 *
 * To run a mutation, you first call `useFinishPasskeyAuthenticationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useFinishPasskeyAuthenticationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useFinishPasskeyAuthenticationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useFinishPasskeyAuthenticationMutation(options: VueApolloComposable.UseMutationOptions<Types.FinishPasskeyAuthenticationMutation, Types.FinishPasskeyAuthenticationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.FinishPasskeyAuthenticationMutation, Types.FinishPasskeyAuthenticationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.FinishPasskeyAuthenticationMutation, Types.FinishPasskeyAuthenticationMutationVariables>(FinishPasskeyAuthenticationDocument, { clientId: 'auth', ...options});
}
export type FinishPasskeyAuthenticationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.FinishPasskeyAuthenticationMutation, Types.FinishPasskeyAuthenticationMutationVariables>;
export const FinishPasskeyRegistrationDocument = gql`
    mutation FinishPasskeyRegistration($input: FinishPasskeyRegistrationInput!) {
  finishPasskeyRegistration(input: $input) {
    ... on Passkey {
      createdAt
      id
      label
      lastUsedAt
    }
    ... on PasskeyErrorCase {
      errors
    }
  }
}
    `;

/**
 * __useFinishPasskeyRegistrationMutation__
 *
 * To run a mutation, you first call `useFinishPasskeyRegistrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useFinishPasskeyRegistrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useFinishPasskeyRegistrationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useFinishPasskeyRegistrationMutation(options: VueApolloComposable.UseMutationOptions<Types.FinishPasskeyRegistrationMutation, Types.FinishPasskeyRegistrationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.FinishPasskeyRegistrationMutation, Types.FinishPasskeyRegistrationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.FinishPasskeyRegistrationMutation, Types.FinishPasskeyRegistrationMutationVariables>(FinishPasskeyRegistrationDocument, { clientId: 'auth', ...options});
}
export type FinishPasskeyRegistrationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.FinishPasskeyRegistrationMutation, Types.FinishPasskeyRegistrationMutationVariables>;
export const GetTwoFactorConfigurationDocument = gql`
    query GetTwoFactorConfiguration {
  twoFactorConfiguration {
    channels {
      activated
      channel
    }
  }
}
    `;

/**
 * __useGetTwoFactorConfigurationQuery__
 *
 * To run a query within a Vue component, call `useGetTwoFactorConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTwoFactorConfigurationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTwoFactorConfigurationQuery();
 */
export function useGetTwoFactorConfigurationQuery(options: VueApolloComposable.UseQueryOptions<Types.GetTwoFactorConfigurationQuery, Types.GetTwoFactorConfigurationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetTwoFactorConfigurationQuery, Types.GetTwoFactorConfigurationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetTwoFactorConfigurationQuery, Types.GetTwoFactorConfigurationQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetTwoFactorConfigurationQuery, Types.GetTwoFactorConfigurationQueryVariables>(GetTwoFactorConfigurationDocument, {}, { clientId: 'auth', ...options});
}
export function useGetTwoFactorConfigurationLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.GetTwoFactorConfigurationQuery, Types.GetTwoFactorConfigurationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetTwoFactorConfigurationQuery, Types.GetTwoFactorConfigurationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetTwoFactorConfigurationQuery, Types.GetTwoFactorConfigurationQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetTwoFactorConfigurationQuery, Types.GetTwoFactorConfigurationQueryVariables>(GetTwoFactorConfigurationDocument, {}, { clientId: 'auth', ...options});
}
export type GetTwoFactorConfigurationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetTwoFactorConfigurationQuery, Types.GetTwoFactorConfigurationQueryVariables>;
export const LogoutDocument = gql`
    mutation Logout {
  logout {
    ... on LogoutPayload {
      result
    }
  }
}
    `;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useLogoutMutation();
 */
export function useLogoutMutation(options: VueApolloComposable.UseMutationOptions<Types.LogoutMutation, Types.LogoutMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.LogoutMutation, Types.LogoutMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.LogoutMutation, Types.LogoutMutationVariables>(LogoutDocument, { clientId: 'auth', ...options});
}
export type LogoutMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.LogoutMutation, Types.LogoutMutationVariables>;
export const PasskeysDocument = gql`
    query Passkeys {
  passkeys {
    passkeys {
      createdAt
      id
      label
      lastUsedAt
    }
  }
}
    `;

/**
 * __usePasskeysQuery__
 *
 * To run a query within a Vue component, call `usePasskeysQuery` and pass it any options that fit your needs.
 * When your component renders, `usePasskeysQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePasskeysQuery();
 */
export function usePasskeysQuery(options: VueApolloComposable.UseQueryOptions<Types.PasskeysQuery, Types.PasskeysQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.PasskeysQuery, Types.PasskeysQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.PasskeysQuery, Types.PasskeysQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.PasskeysQuery, Types.PasskeysQueryVariables>(PasskeysDocument, {}, { clientId: 'auth', ...options});
}
export function usePasskeysLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.PasskeysQuery, Types.PasskeysQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.PasskeysQuery, Types.PasskeysQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.PasskeysQuery, Types.PasskeysQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.PasskeysQuery, Types.PasskeysQueryVariables>(PasskeysDocument, {}, { clientId: 'auth', ...options});
}
export type PasskeysQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.PasskeysQuery, Types.PasskeysQueryVariables>;
export const StartPasskeyAuthenticationDocument = gql`
    mutation StartPasskeyAuthentication {
  startPasskeyAuthentication {
    ... on PasskeyErrorCase {
      errors
    }
    ... on StartPasskeyAuthenticationPayload {
      ceremonyId
      options
    }
  }
}
    `;

/**
 * __useStartPasskeyAuthenticationMutation__
 *
 * To run a mutation, you first call `useStartPasskeyAuthenticationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStartPasskeyAuthenticationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStartPasskeyAuthenticationMutation();
 */
export function useStartPasskeyAuthenticationMutation(options: VueApolloComposable.UseMutationOptions<Types.StartPasskeyAuthenticationMutation, Types.StartPasskeyAuthenticationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.StartPasskeyAuthenticationMutation, Types.StartPasskeyAuthenticationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.StartPasskeyAuthenticationMutation, Types.StartPasskeyAuthenticationMutationVariables>(StartPasskeyAuthenticationDocument, { clientId: 'auth', ...options});
}
export type StartPasskeyAuthenticationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.StartPasskeyAuthenticationMutation, Types.StartPasskeyAuthenticationMutationVariables>;
export const StartPasskeyRegistrationDocument = gql`
    mutation StartPasskeyRegistration {
  startPasskeyRegistration {
    ... on PasskeyErrorCase {
      errors
    }
    ... on StartPasskeyRegistrationPayload {
      options
    }
  }
}
    `;

/**
 * __useStartPasskeyRegistrationMutation__
 *
 * To run a mutation, you first call `useStartPasskeyRegistrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStartPasskeyRegistrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStartPasskeyRegistrationMutation();
 */
export function useStartPasskeyRegistrationMutation(options: VueApolloComposable.UseMutationOptions<Types.StartPasskeyRegistrationMutation, Types.StartPasskeyRegistrationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.StartPasskeyRegistrationMutation, Types.StartPasskeyRegistrationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.StartPasskeyRegistrationMutation, Types.StartPasskeyRegistrationMutationVariables>(StartPasskeyRegistrationDocument, { clientId: 'auth', ...options});
}
export type StartPasskeyRegistrationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.StartPasskeyRegistrationMutation, Types.StartPasskeyRegistrationMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation ChangePassword($input: ChangePasswordInput!) {
  changePassword(input: $input) {
    ... on ChangePasswordPayload {
      result
    }
  }
}
    `;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useChangePasswordMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useChangePasswordMutation(options: VueApolloComposable.UseMutationOptions<Types.ChangePasswordMutation, Types.ChangePasswordMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ChangePasswordMutation, Types.ChangePasswordMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ChangePasswordMutation, Types.ChangePasswordMutationVariables>(ChangePasswordDocument, { clientId: 'auth', ...options});
}
export type ChangePasswordMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ChangePasswordMutation, Types.ChangePasswordMutationVariables>;
export const GetElevatedTokenDocument = gql`
    mutation GetElevatedToken($input: RefreshTokenInput!) {
  getElevatedToken: refreshToken(input: $input) {
    ... on TokenPayload {
      accessToken
      accessTokenType
    }
  }
}
    `;

/**
 * __useGetElevatedTokenMutation__
 *
 * To run a mutation, you first call `useGetElevatedTokenMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useGetElevatedTokenMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useGetElevatedTokenMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useGetElevatedTokenMutation(options: VueApolloComposable.UseMutationOptions<Types.GetElevatedTokenMutation, Types.GetElevatedTokenMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.GetElevatedTokenMutation, Types.GetElevatedTokenMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.GetElevatedTokenMutation, Types.GetElevatedTokenMutationVariables>(GetElevatedTokenDocument, { clientId: 'auth', ...options});
}
export type GetElevatedTokenMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.GetElevatedTokenMutation, Types.GetElevatedTokenMutationVariables>;
export const LoginDocument = gql`
    mutation Login($input: LoginInput!) {
  login(input: $input) {
    ... on TokenPayload {
      accessToken
      accessTokenType
    }
  }
}
    `;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useLoginMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(options: VueApolloComposable.UseMutationOptions<Types.LoginMutation, Types.LoginMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.LoginMutation, Types.LoginMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.LoginMutation, Types.LoginMutationVariables>(LoginDocument, { clientId: 'auth', ...options});
}
export type LoginMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.LoginMutation, Types.LoginMutationVariables>;
export const RefreshTokenDocument = gql`
    mutation RefreshToken {
  refreshToken {
    ... on TokenPayload {
      accessToken
      accessTokenType
    }
  }
}
    `;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRefreshTokenMutation();
 */
export function useRefreshTokenMutation(options: VueApolloComposable.UseMutationOptions<Types.RefreshTokenMutation, Types.RefreshTokenMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RefreshTokenMutation, Types.RefreshTokenMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RefreshTokenMutation, Types.RefreshTokenMutationVariables>(RefreshTokenDocument, { clientId: 'auth', ...options});
}
export type RefreshTokenMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RefreshTokenMutation, Types.RefreshTokenMutationVariables>;
export const RequestPasswordResetDocument = gql`
    mutation RequestPasswordReset($input: RequestPasswordResetInput!) {
  requestPasswordReset(input: $input) {
    ... on RequestPasswordResetPayload {
      result
    }
  }
}
    `;

/**
 * __useRequestPasswordResetMutation__
 *
 * To run a mutation, you first call `useRequestPasswordResetMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordResetMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRequestPasswordResetMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRequestPasswordResetMutation(options: VueApolloComposable.UseMutationOptions<Types.RequestPasswordResetMutation, Types.RequestPasswordResetMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RequestPasswordResetMutation, Types.RequestPasswordResetMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RequestPasswordResetMutation, Types.RequestPasswordResetMutationVariables>(RequestPasswordResetDocument, { clientId: 'auth', ...options});
}
export type RequestPasswordResetMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RequestPasswordResetMutation, Types.RequestPasswordResetMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($input: ResetPasswordInput!) {
  resetPassword(input: $input) {
    ... on ResetPasswordPayload {
      result
    }
  }
}
    `;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResetPasswordMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordMutation(options: VueApolloComposable.UseMutationOptions<Types.ResetPasswordMutation, Types.ResetPasswordMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ResetPasswordMutation, Types.ResetPasswordMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ResetPasswordMutation, Types.ResetPasswordMutationVariables>(ResetPasswordDocument, { clientId: 'auth', ...options});
}
export type ResetPasswordMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ResetPasswordMutation, Types.ResetPasswordMutationVariables>;
export const SignUpDocument = gql`
    mutation SignUp($input: SignUpInput!) {
  signUp(input: $input) {
    ... on GraphQLErrorCase {
      errors
    }
    ... on TokenPayload {
      accessToken
      accessTokenType
    }
  }
}
    `;

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSignUpMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSignUpMutation(options: VueApolloComposable.UseMutationOptions<Types.SignUpMutation, Types.SignUpMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.SignUpMutation, Types.SignUpMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.SignUpMutation, Types.SignUpMutationVariables>(SignUpDocument, { clientId: 'auth', ...options});
}
export type SignUpMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.SignUpMutation, Types.SignUpMutationVariables>;
export const TwoFactorAuthenticationLoginDocument = gql`
    mutation TwoFactorAuthenticationLogin($input: TwoFactorAuthenticationLoginInput!) {
  twoFactorAuthenticationLogin(input: $input) {
    ... on TokenPayload {
      accessToken
      accessTokenType
    }
  }
}
    `;

/**
 * __useTwoFactorAuthenticationLoginMutation__
 *
 * To run a mutation, you first call `useTwoFactorAuthenticationLoginMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTwoFactorAuthenticationLoginMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTwoFactorAuthenticationLoginMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useTwoFactorAuthenticationLoginMutation(options: VueApolloComposable.UseMutationOptions<Types.TwoFactorAuthenticationLoginMutation, Types.TwoFactorAuthenticationLoginMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.TwoFactorAuthenticationLoginMutation, Types.TwoFactorAuthenticationLoginMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.TwoFactorAuthenticationLoginMutation, Types.TwoFactorAuthenticationLoginMutationVariables>(TwoFactorAuthenticationLoginDocument, { clientId: 'auth', ...options});
}
export type TwoFactorAuthenticationLoginMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.TwoFactorAuthenticationLoginMutation, Types.TwoFactorAuthenticationLoginMutationVariables>;